export default __webpack_public_path__ + "static/media/avatar_sunshine_cat1.2922aea6.mp3";